<div class="r-box-header mg-b40 mg-t40">
    Frequently asked Questions
</div>
<accordion [isAnimated]="true">
    <accordion-group #group *ngFor="let section of sections" [isOpen]="section.visible">
        <div class="faq-header" accordion-heading>
            <h3 [innerHTML]="section.header"></h3>
            <img src="/assets/new-dashboard/expand.png" *ngIf="group.isOpen">
            <img src="/assets/new-dashboard/right.png" *ngIf="!group.isOpen">
        </div>
        <p [innerHTML]="section.text"></p>
    </accordion-group>
</accordion>